import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/tokens.css';
import './scss/buttons.css';
import './scss/modal-form.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import process from 'process';

// Asegura polyfill de process en navegador
if (typeof window !== 'undefined' && !window.process) {
  window.process = process;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
